import type {BioIconProps} from './../common-types'

export function FaqIconChevronUp({strokeWidth = '1', ...attributes}: BioIconProps) {
  return (
    <svg width="20" height="12" viewBox="0 0 20 12" fill="none" xmlns="http://www.w3.org/2000/svg" {...attributes}>
      <path
        fill="none"
        stroke="#676879"
        strokeWidth={strokeWidth}
        fillRule="evenodd"
        clipRule="evenodd"
        d="M18.1484 10.0625L9.99969 1.95058L1.85095 10.0625"
      />
    </svg>
  )
}
